export default [

    {
        path: '/questoes',
        view: 'questao/Index',
        name: 'Questões',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questões',
                disabled: true,
                exact: true,
                to: '/questoes',
            },
        ],
    },
    {
        path: '/questoes/novo',
        view: 'questao/New',
        name: 'Cadastrar Questão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questões',
                disabled: false,
                exact: true,
                to: '/questoes',
            },
            {
                text: 'Novo',
                disabled: true,
                exact: true,
                to: '/questoes/novo',
            }
        ],
    },
    {
        path: '/questoes/editar/:id',
        view: 'questao/Edit',
        name: 'Edição de Questão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questões',
                disabled: false,
                exact: true,
                to: '/questoes',
            },
            {
                text: 'Editar',
                disabled: true,
                exact: true,
                to: '/questoes/editar/:id',
            }
        ],
    },
    {
        path: '/questoes/ordenar/:eixoId?',
        view: 'questao/Ordenacao',
        name: 'Ordenação de Questões',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questões',
                disabled: false,
                exact: true,
                to: '/questoes',
            },
            {
                text: 'Ordenação',
                disabled: true,
                exact: true,
                to: '/questoes/ordenar/:eixoId',
            }
        ],
    },
    {
        path: '/questoes/visualizar/:id',
        view: 'questao/View',
        name: 'Visualização de Questão',
        permissions: ['ADMINISTRADOR', 'GESTOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Questões',
                disabled: false,
                exact: true,
                to: '/questoes',
            },
            {
                text: 'Visulização',
                disabled: true,
                exact: true,
                to: '/questoes/visualizar/:id',
            }
        ],
    },
];
